import React, { useState, useRef, useEffect } from "react";
import { ListFilter, UserSearch } from "lucide-react";
import { datePickerFormat, getSecureData, notify, setSecureData } from "../../helpers";
import { getMeasures } from "../../services/caregaps";
import { useLocation } from "react-router-dom";
import { fetchSpecialist } from "../../services/easyReferral";
import { Drawer } from 'vaul';
import DatePicker from "react-datepicker";
import Select from "react-select";
import Spacing from "../Spacing";
import DropdownWithSearch from "../DropdownWithSearch";
import MultiSelectWithSearch from "../MultiSelectWithSearch";
import Inputmask from "inputmask";

const selectStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px solid #D1D5DB",
    minHeight: '36px',
    borderRadius: '8px',
    boxShadow: state.isFocused ? "0 0 0 .5px var(--accent)" : "none",
    "&:hover": {
      borderColor: "#9CA3AF",
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "0.875rem",
    color: "#9CA3AF",
    fontWeight: "normal",
  }),
  option: (base) => ({ ...base, cursor: "pointer" }),
  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
  menu: (base) => ({
    ...base,
    marginTop: '-1px',
    border: "1px solid #D1D5DB",
    borderRadius: "0 0 0.375rem 0.375rem",
    zIndex: 999999,
  }),
};

export default function Filter({
  filterType,
  reloadData = () => {},
  reloadDataFilter = {},
  staticFilter = {},
  setDataLoading = () => {},
  parseQualityMeasure = () => {},
  isEnable = true,
  reloadReferralFilter = {},
  reloadSetReferralFilter = () => {},
  isFilterCleared , 
  onResetFilterStatus,
  selectedInsuranceOptions = [], // Provide a default empty array
  setSelectedInsuranceOptions = () => {}, // Provide a default empty array
  patientFormData,
  setPatientFormData,
  selectedMeasures, // Provide a default empty array
  setSelectedMeasures = ()  => {}, // Provide a default empty array
  setShowSave = () => {},
  vtOptions = [],
  parseMips = () => {},
  allMips = {},
  selectedMips,
  setSelectedMips = ()  => {},
  visitStatusOptions = [],
  practiceLocationsOptions = [],
  allMessageTemplate = [],
  allStatusOptions = []
}) {
  const [activeModal, setActiveModal] = useState(false);
  const [isReporting, setIsReporting] = useState(1);
  const [isReferralReporting, setIsReferralReporting] = useState(1);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [measuresData, setMeasuresData] = useState([]);
  const dropdownRef = useRef(null);
  const patientDefaultValues = {
    page: 1,
    per_page: 10,
    search_term: "",
    first_name: "",
    last_name: "",
    dob: "",
    sex: "",
    mobile_phone: "",
    start_age: "",
    end_age: "",
    insurance_ids: [],
    last_visit: "",
    visit_day_query_type: "",
    visited_last_days: "",
    not_visited_last_days: "",
    quality_measure: [],
    city: "",
    state: "",
    zip: "",
    dos: "",
    status: "",
    vt_name: ""
  };

  const practiceDefaultValues = {
    page: 1,
    per_page: 10,
    search_term: "",
    provider_name: "",
    practice_name: "",
    city: "",
    practice_state: "",
    postal_code: "",
    speciality_ids: [],
  };

  const defaultMipsFilter = {
    page: 1,
    per_page: 10,
    search_term: "",
    name: "",
    dob: "",
    sex: "",
    mobile_phone: "",
    start_age: "",
    end_age: "",
    mips: []
  };
  const [practiceFormData, setPracticeFormData] = useState(practiceDefaultValues);
  const [patientInsuranceOptions, setPatientInsuranceOptions] = useState([]);
  const [practiceSpecialityOptions, setPracticeSpecialityOptions] = useState([]);
  const [selectedSpecialityOptions, setSelectedSpecialityOptions] = useState([]);
  const location = useLocation();
  const defaultRejectionData = {
    page: 1,
    per_page: 10,
    status: "",
    search_term: "",
    first_name: "",
    last_name: "",
    dob: "",
    insurance_name: "",
    insurance_ids: "",
    dos_from: "",
    dos_to: "",
    resubmit_date_from: "",
    resubmit_date_to: "",
  };
  const [referralFilterData, setFeferralFilterData] = useState(defaultRejectionData);
  const [drawerPosition, setDrawerPosition] = useState({ top: 0 });

  const changeStartDate = (date) => {
    setStartDate(date);
  };

  const changeEndDate = (date) => {
    setEndDate(date);
  };

  const handleGenerate = () => {
    reloadData(startDate, endDate);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleResetFilters = () => {
    setStartDate(new Date());
    setEndDate(new Date());
    reloadData(null, null);
    setDataLoading(true);
    setActiveModal(false);
  };

  useEffect(() => {
    if (filterType === "patient_caregap") {
      const paramsQualityMeasure = parseQualityMeasure();
      if (paramsQualityMeasure.length === 0) {
        setSelectedMeasures(paramsQualityMeasure);
      } else {
        const qualityMeasure = reloadDataFilter.quality_measure;
        if (qualityMeasure.length > 0) {
          setSelectedMeasures(qualityMeasure);
        }
      }
    }
    if (filterType === "patient_mips") {
      const paramsMips = parseMips();
      if (paramsMips.length === 0) {
        setSelectedMips(paramsMips);
      } else {
        const mips = reloadDataFilter.quality_measure;
        if (mips.length > 0) {
          setSelectedMips(mips);
        }
      }
    }
  }, [location.search]);

  const calculateDrawerPosition = () => {
    const triggerElement = document.querySelector('.docpro_filter');
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      setDrawerPosition({
        top: rect.bottom + window.scrollY,
      });
    }
    if (patientFormData.dos === "") {
      setPatientFormData({
        ...patientFormData,
        dos: reloadDataFilter.dos,
      });
    } else if (reloadDataFilter.dos === "") {
      setPatientFormData({
        ...patientFormData,
        dos: "",
      });
    }
    if(selectedMeasures?.length) {
      setPatientFormData({
        ...patientFormData,
        quality_measure: selectedMeasures,
      });
    }
    if(selectedMips?.length) {
      setPatientFormData({
        ...patientFormData,
        mips: selectedMips,
      });
    }
    setActiveModal(!activeModal);
  };

  useEffect(() => {
    if (filterType !== "patient_mips") {
      loadInsurance();
      loadSpeciality();
    }
  }, []);

  const loadInsurance = async () => {
    if(filterType === "fidelis_care") {
      return;
    }    
    const insurancesData = await getSecureData("practice_insurances_group");    
    setPatientInsuranceOptions(insurancesData || []);

    if (filterType === "patient_caregap") {
      const _all_care_gaps = await getSecureData("all_care_gaps");
      if (!_all_care_gaps) {
        const response = await getMeasures();
        if (response) {
          setMeasuresData(response?.data);
          await setSecureData("all_care_gaps", JSON.stringify(response?.data));
        }
      } else {
        setMeasuresData(_all_care_gaps);
      }
      try {
        handleQMToggle(
          "quality_measure",
          reloadDataFilter.quality_measure[0].id,
          true,
          reloadDataFilter.quality_measure[0].status
        );
      } catch (e) {}
    }
  };

  const handlePatientChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_phone") {
      const phoneInputs = document.querySelectorAll(".us_phone");
      Inputmask({
        mask: "(999) 999-9999",
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    setPatientFormData((prevData) => {
      let updatedFormData = {
        ...prevData,
        // ...reloadDataFilter,
        [name]: value,
      };

      if (name === "visited_last_days" && value) {
        updatedFormData.not_visited_last_days = "";
        updatedFormData.visit_day_query_type = "1";
      } else if (name === "not_visited_last_days" && value) {
        updatedFormData.visited_last_days = "";
        updatedFormData.visit_day_query_type = "2";
      }

      return updatedFormData;
    });
  };
  
  const handleChangePatientDate = (name, value) => {
    // Update the state with the modified date
    setPatientFormData({
      ...patientFormData,
      [name]: datePickerFormat(value),
    });
  };

  const handleOptionToggle = (name, optionId) => {
    const index = selectedInsuranceOptions.indexOf(optionId);
    if (index === -1) {
      setSelectedInsuranceOptions([...selectedInsuranceOptions, optionId]);
    } else {
      setSelectedInsuranceOptions(
        selectedInsuranceOptions.filter((id) => id !== optionId)
      );
    }
    setPatientFormData({
      ...patientFormData,
      [name]: selectedInsuranceOptions.includes(optionId)
        ? selectedInsuranceOptions.filter((id) => id !== optionId)
        : [...selectedInsuranceOptions, optionId],
    });
  };

  const handleQMToggle = (name, id, active, status) => {
    const index = selectedMeasures.findIndex((measure) => measure.id === id);
    const updatedMeasures = [...selectedMeasures];

    if (active === true) {
      if (index !== -1) {
        updatedMeasures[index].status = status;
      } else {
        updatedMeasures.push({ id, status });
      }
    } else {
      if (index !== -1) {
        updatedMeasures.splice(index, 1);
      }
    }

    setSelectedMeasures(updatedMeasures);

    setPatientFormData({
      ...patientFormData,
      [name]: updatedMeasures,
    });
  };

  const handleMIPSToggle = (name, id, active, status) => {
    const index = selectedMips.findIndex((measure) => measure.id === id);
    const updatedMips = [...selectedMips];

    if (active === true) {
      if (index !== -1) {
        updatedMips[index].status = status;
      } else {
        updatedMips.push({ id, status });
      }
    } else {
      if (index !== -1) {
        updatedMips.splice(index, 1);
      }
    }

    setSelectedMips(updatedMips);

    setPatientFormData({
      ...patientFormData,
      [name]: updatedMips,
    });
  };

  const handlePatientFilterSubmit = async (e) => {
    e.preventDefault();
    const updateFilter_data = { ...reloadDataFilter, ...patientFormData };
    const updateFilter = { ...updateFilter_data, ...staticFilter };
    reloadData(updateFilter);
    setDataLoading(true);
    if (filterType !== "patient_mips") {
      setShowSave(true);
    }
    setActiveModal(false);
  };

  const handleReferralChange = (e) => {
    const { name, value } = e.target;

    setFeferralFilterData((prevData) => {
      let updatedFormData = {
        ...prevData,
        [name]: value,
      };
      return updatedFormData;
    });
  };

  const handleReferralInsToggle = (name, optionId) => {
    const index = selectedInsuranceOptions.indexOf(optionId);
    if (index === -1) {
      setSelectedInsuranceOptions([...selectedInsuranceOptions, optionId]);
    } else {
      setSelectedInsuranceOptions(
        selectedInsuranceOptions.filter((id) => id !== optionId)
      );
    }
    setFeferralFilterData({
      ...referralFilterData,
      [name]: selectedInsuranceOptions.includes(optionId)
        ? selectedInsuranceOptions.filter((id) => id !== optionId)
        : [...selectedInsuranceOptions, optionId],
    });
  };

  const handleChangeReferralDate = (name, value) => {
    setFeferralFilterData({
      ...referralFilterData,
      [name]: datePickerFormat(value),
    });
  };

  const handleReferralFilterSubmit = async (e) => {
    e.preventDefault();
    
    if ((referralFilterData.dos_to !== "" && referralFilterData.dos_to !== null) &&
    (referralFilterData.dos_from === "" || referralFilterData.dos_from === null)) {
      notify("error", "Without a given from date, you can't provide a to date", 2);
      return;
    }
    if ((referralFilterData.resubmit_date_to !== "" && referralFilterData.resubmit_date_to !== null) &&
    (referralFilterData.resubmit_date_from === "" || referralFilterData.resubmit_date_from === null)) {
      notify("error", "Without a given from date, you can't provide a to date", 2);
      return;
    }

    const updateFilter_data = { ...reloadDataFilter, ...referralFilterData };
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handlePracticeFilterSubmit = async (e) => {
    e.preventDefault();
    const updateFilter = { ...reloadDataFilter, ...practiceFormData };
    reloadData(updateFilter);
    setDataLoading(true);
    setActiveModal(false);
  };


  const ResetAllFilters = (DefaultValues) => {
    const urlWithoutParams = window.location.pathname;
    window.history.replaceState({}, document.title, urlWithoutParams);

    const filter_merge = { ...reloadDataFilter, ...DefaultValues };
    const updateFilter = { ...filter_merge, ...staticFilter };
    reloadData(updateFilter);
    setPatientFormData(updateFilter);
    setFeferralFilterData(updateFilter);
    setPracticeFormData(updateFilter);
    const resetRadioButtons = document.querySelectorAll('input[type="radio"]');
    resetRadioButtons.forEach((button) => {
      button.checked = false;
    });
    const resetCheckboxs = document.querySelectorAll('input[type="checkbox"]');
    resetCheckboxs.forEach((button) => {
      button.checked = false;
    });
    // const updatedMeasures = selectedMeasures.map(measure => ({
    //   ...measure,
    //   status: "pending"
    // }));
    setSelectedMeasures();
    if (filterType === "patient_mips") {
      setSelectedMips();
    }
    setDataLoading(true);
    setActiveModal(false);
  };


  const handleClearFilters = () => {
    setSelectedInsuranceOptions([]);
    setPatientFormData(patientDefaultValues); // Reset patient form data to defaults
    ResetAllFilters(patientDefaultValues); // Call ResetAllFilters with defaults

    // Call the parent component's function to reset `isFilterCleared` to false
    onResetFilterStatus();
    setActiveModal(false);
  };

  useEffect(() => {
    if (isFilterCleared) {
      handleClearFilters();
      setPatientFormData(patientDefaultValues);
    }
  }, [isFilterCleared]);

  const handleAIChartingFilterSubmit = async (e) => {
    e.preventDefault();

    const updateFilter = { ...reloadDataFilter, ...patientFormData };
    reloadData(updateFilter);
    setDataLoading(true);
    setActiveModal(false);
  };

  // Speciality Filter
  const loadSpeciality = async () => {
    if(filterType === "fidelis_care") {
      return;
    }
    const response = await fetchSpecialist();
    if (response) {
      const generateData = response.data.results;
      setPracticeSpecialityOptions(generateData);
    }
  };

  const handleSpecialityToggle = (name, optionId) => {
    const index = selectedSpecialityOptions.indexOf(optionId);
    if (index === -1) {
      setSelectedSpecialityOptions([...selectedSpecialityOptions, optionId]);
    } else {
      setSelectedSpecialityOptions(
        selectedSpecialityOptions.filter((id) => id !== optionId)
      );
    }
    setPracticeFormData({
      ...practiceFormData,
      [name]: selectedSpecialityOptions.includes(optionId)
        ? selectedSpecialityOptions.filter((id) => id !== optionId)
        : [...selectedSpecialityOptions, optionId],
    });
  };

  const handlePracticeChange = (e) => {
    const { name, value } = e.target;

    setPracticeFormData({
      ...practiceFormData,
      [name]: value,
    });
  };

  // Referral Filter
  const handlereferralChange = (e) => {
    const { name, value } = e.target;

    if (name === "patient_mobile_phone" || name === "practice_mobile_phone") {
      const phoneInputs = document.querySelectorAll(".us_phone");
      Inputmask({
        mask: "(999) 999-9999",
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    reloadSetReferralFilter({
      ...reloadReferralFilter,
      [name]: value,
    });
  };

  const handleInsuranceOptionToggle = (name, optionId) => {
    const index = selectedInsuranceOptions.indexOf(optionId);
    if (index === -1) {
      setSelectedInsuranceOptions([...selectedInsuranceOptions, optionId]);
    } else {
      setSelectedInsuranceOptions(
        selectedInsuranceOptions.filter((id) => id !== optionId)
      );
    }
    reloadSetReferralFilter({
      ...reloadReferralFilter,
      [name]: selectedInsuranceOptions.includes(optionId)
        ? selectedInsuranceOptions.filter((id) => id !== optionId)
        : [...selectedInsuranceOptions, optionId],
    });
  };

  const handleReferSpecialityToggle = (name, optionId) => {
    const index = selectedSpecialityOptions.indexOf(optionId);
    if (index === -1) {
      setSelectedSpecialityOptions([...selectedSpecialityOptions, optionId]);
    } else {
      setSelectedSpecialityOptions(
        selectedSpecialityOptions.filter((id) => id !== optionId)
      );
    }
    reloadSetReferralFilter({
      ...reloadReferralFilter,
      [name]: selectedSpecialityOptions.includes(optionId)
        ? selectedSpecialityOptions.filter((id) => id !== optionId)
        : [...selectedSpecialityOptions, optionId],
    });
  };

  const handleEasyReferralFilterSubmit = async (e) => {
    e.preventDefault();
    const updateFilter = { ...reloadReferralFilter };
    reloadSetReferralFilter(updateFilter);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleRFVChange = (selectedOption) => {
    setPatientFormData({ ...patientFormData, vt_name: selectedOption?.value || "" });
  };

  const handleChangeFidelisPatientDate = (name, value) => {
    setPatientFormData({
      ...patientFormData,
      [name]: datePickerFormat(value),
    });
  };

  const handleChangeFidelisPatientData = (e) => {
    const { name, value } = e.target;

    setPatientFormData((prevData) => {
      let updatedFormData = {
        ...prevData,
        [name]: value,
      };
      return updatedFormData;
    });
  };

  const handleFidelisPatientFilterSubmit = async (e) => {
    e.preventDefault();
    const updateFilter_data = { ...reloadDataFilter, ...patientFormData };
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleClearFidelisFilters = () => {
    const defaultFidelisFilter = {
      start_date: "",
      end_date: "",
      gender: "",
      visit_status: "",
      practice_location: ""
    }
    const updateFilter_data = { ...reloadDataFilter, ...defaultFidelisFilter };
    setPatientFormData(updateFilter_data);
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleClearFidelisIncomingFilters = () => {
    const defaultFidelisFilter = {
      start_date: "",
      end_date: "",
    }
    const updateFilter_data = { ...reloadDataFilter, ...defaultFidelisFilter };
    setPatientFormData(updateFilter_data);
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleGenerateIncomingMessage = () => {
    const updateFilter_data = { ...reloadDataFilter, ...patientFormData };
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleClearFidelisOutgoingFilters = () => {
    const defaultFidelisFilter = {
      status: "",
      template_id: null,
      practice_location: ""
    }
    const updateFilter_data = { ...reloadDataFilter, ...defaultFidelisFilter };
    setPatientFormData(updateFilter_data);
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  const handleGenerateOutgoingMessage = (e) => {
    e.preventDefault();
    const updateFilter_data = { ...reloadDataFilter, ...patientFormData };
    reloadData(updateFilter_data);
    setDataLoading(true);
    setActiveModal(false);
  };

  return (
    <div className="small_device" style={{ position: "relative" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal}>
        <Drawer.Trigger
          className="docpro_filter docpro_fw_500"
          onClick={() => calculateDrawerPosition()}
        >
          <ListFilter width={16} height={16} />
          Filter
        </Drawer.Trigger>

        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content
            className="docpro_drawer_content"
            style={{
              top: drawerPosition.top,
              right: '30px',
              position: 'absolute',
            }}
          >
            <Drawer.Title className="sr-only">Filter Data</Drawer.Title>
            <Drawer.Description className="sr-only">A menu for the user to filter data table.</Drawer.Description>
            <div className="docpro_drawer_content_in">
              {filterType === "general" && (
                <div className="docpro_filter_dropdown_body docpro_size_md custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Waiting room Filter</h4>
                  <Spacing lg="16" sm="16" />
                  <label className="docpro_fw_500 docpro_primary_color">
                    Date range (DOS)
                  </label>
                  <div className="docpro_input_group">
                    <DatePicker selected={startDate} onChange={changeStartDate} />
                    -
                    <DatePicker selected={endDate} onChange={changeEndDate} />
                  </div>
                  <Spacing lg="28" sm="28" />
                  <div className="docpro_filter_dropdown_btns">
                    <button
                      className="docpro_text_btn docpro_accent_color docpro_fw_600"
                      onClick={handleResetFilters}
                    >
                      Reset all filters
                    </button>
                    <button
                      className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                      onClick={handleGenerate}
                    >
                      <UserSearch /> Generate
                    </button>
                  </div>
                </div>
              )}
              {filterType === "advance" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Reporting</h4>
                  <Spacing lg="16" sm="16" />
                  <div className="docpro_tab_btns_2">
                    <button
                      type="button"
                      className={`${isReporting === 1 ? "active" : ""}`}
                      onClick={() => setIsReporting(1)}
                    >
                      Custom
                    </button>
                    <button
                      type="button"
                      className={`${isReporting === 2 ? "active" : ""}`}
                      onClick={() => setIsReporting(2)}
                    >
                      Pre-defined
                    </button>
                  </div>
                  <Spacing lg="16" sm="16" />
                  {isReporting === 1 && (
                    <>
                      <label className="docpro_fw_500 docpro_primary_color">
                        Visit date range
                      </label>
                      <div className="docpro_input_group">
                        <DatePicker
                          selected={startDate}
                          onChange={changeStartDate}
                        />
                        -
                        <DatePicker selected={endDate} onChange={changeEndDate} />
                      </div>
                      <Spacing lg="8" sm="8" />
                      <ul className="docpro_year_radios">
                        <li>
                          <input type="radio" name="year" />
                          <span>1 Year</span>
                        </li>
                        <li>
                          <input type="radio" name="year" />
                          <span>9 months</span>
                        </li>
                        <li>
                          <input type="radio" name="year" />
                          <span>6 months</span>
                        </li>
                        <li>
                          <input type="radio" name="year" />
                          <span>3 months</span>
                        </li>
                      </ul>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Quality measure status
                      </label>
                      <DropdownWithSearch placeholder="Select Status">
                        <ul className="docpro_checkmark_list">
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>
                                  Breast cancer screening
                                </span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Blue</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </DropdownWithSearch>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Chronic condition
                      </label>
                      <DropdownWithSearch placeholder="Select chronic condition">
                        <ul className="docpro_checkmark_list">
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Red</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Blue</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </DropdownWithSearch>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance
                      </label>
                      <DropdownWithSearch placeholder="Select insurance">
                        <ul className="docpro_checkmark_list">
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Red</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Blue</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input type="checkbox" />
                              <label>
                                <span style={{ marginLeft: "8px" }}>Peach</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </DropdownWithSearch>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Age range
                      </label>
                      <div className="docpro_input_group">
                        <input
                          type="text"
                          placeholder="0"
                          className="docpro_form_field"
                        />
                        -
                        <input
                          type="text"
                          placeholder="100"
                          className="docpro_form_field"
                        />
                      </div>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        AI sorting
                      </label>
                      <div className="docpro_switch">
                        <input className="form-check-input" type="checkbox" />
                        <span></span>
                      </div>
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender
                      </label>
                      <div className="docpro_radio_group">
                        <div className="docpro_radio">
                          <input type="radio" name="gender" />
                          <label style={{ paddingLeft: "30px" }}>All</label>
                        </div>
                        <div className="docpro_radio">
                          <input type="radio" name="gender" />
                          <label style={{ paddingLeft: "30px" }}>Male</label>
                        </div>
                        <div className="docpro_radio">
                          <input type="radio" name="gender" />
                          <label style={{ paddingLeft: "30px" }}>Female</label>
                        </div>
                        <div className="docpro_radio">
                          <input type="radio" name="gender" />
                          <label style={{ paddingLeft: "30px" }}>Other</label>
                        </div>
                      </div>
                    </>
                  )}
                  {isReporting === 2 && (
                    <>
                      <div className="docpro_radio_with_text">
                        <div className="docpro_radio">
                          <input type="radio" name="preDefined" />
                          <label></label>
                        </div>
                        Patients who haven't visited your clinic in
                        <input type="text" className="docpro_form_field" /> days
                      </div>
                      <Spacing lg="15" sm="15" />
                      <div className="docpro_radio_with_text">
                        <div className="docpro_radio">
                          <input type="radio" name="preDefined" />
                          <label></label>
                        </div>
                        Patients who visited your clinic
                        <input type="text" className="docpro_form_field" /> times in
                        <input type="text" className="docpro_form_field" /> months.
                      </div>
                    </>
                  )}
                  <Spacing lg="28" sm="28" />
                  <div className="docpro_filter_dropdown_btns">
                    <button className="docpro_text_btn docpro_accent_color docpro_fw_600">
                      Reset all filters
                    </button>
                    <button className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn">
                      <UserSearch /> Generate
                    </button>
                  </div>
                </div>
              )}
              {filterType === "patient" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Patient Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handlePatientFilterSubmit} autoComplete="off">
                    <div className="custom-scroll" >
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance
                        {selectedInsuranceOptions.length !== 0 && (
                          <span className="docpro_green_color docpro_fs_14">
                            ({selectedInsuranceOptions.length})
                          </span>
                        )}
                      </label>

                      <MultiSelectWithSearch
                        placeholder="Select insurance"
                        style={{ width: "100%" }}
                        showSearch={true}
                      >
                        {patientInsuranceOptions.map((insurance) => (
                          <li
                            key={insurance.id}
                            onClick={() =>
                              handleOptionToggle("insurance_ids", insurance.id)
                            }
                          >
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input
                                type="checkbox"
                                checked={selectedInsuranceOptions.includes(
                                  insurance.id
                                )}
                                readOnly
                                value={insurance.id}
                              />
                              <label>
                                <span style={{ marginLeft: "8px" }}>
                                  {insurance.name}
                                </span>
                              </label>
                            </div>
                          </li>
                        ))}
                      </MultiSelectWithSearch>

                      <Spacing lg="15" sm="15" />
                      <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Age range
                          </label>
                          <div className="docpro_input_group">
                            <input
                              type="number"
                              name="start_age"
                              placeholder="0"
                              className="docpro_form_field"
                              value={patientFormData.start_age}
                              onChange={handlePatientChange}
                            />
                            -
                            <input
                              type="number"
                              name="end_age"
                              placeholder="120"
                              className="docpro_form_field"
                              value={patientFormData.end_age}
                              onChange={handlePatientChange}
                            />
                          </div>
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Last Visit
                          </label>
                          <div className="docpro_input_group">
                            <DatePicker
                              name="last_visit"
                              placeholderText="mm/dd/yyyy"
                              selected={patientFormData.last_visit}
                              onChange={(date) =>
                                handleChangePatientDate("last_visit", date)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender
                      </label>
                      <div className="docpro_radio_group">
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "A"}
                            value="A"
                          />
                          <label style={{ paddingLeft: "30px" }}>All</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "M"}
                            value="M"
                          />
                          <label style={{ paddingLeft: "30px" }}>Male</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "F"}
                            value="F"
                          />
                          <label style={{ paddingLeft: "30px" }}>Female</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "U"}
                            value="U"
                          />
                          <label style={{ paddingLeft: "30px" }}>Other</label>
                        </div>
                      </div>
                      {!staticFilter.visit_day_query_type && isEnable && (
                        <>
                          <Spacing lg="15" sm="15" />
                          <div className="docpro_radio_with_text">
                            <span className="docpro_radio">
                              <input
                                onChange={handlePatientChange}
                                checked={
                                  patientFormData.visit_day_query_type === "1"
                                }
                                type="radio"
                                name="visit_day_query_type"
                                value={1}
                              />
                              <label style={{ marginLeft: "5px" }}>
                                Patients who visited your clinic in
                              </label>
                            </span>
                            <input
                              onChange={handlePatientChange}
                              type="number"
                              min={0}
                              name="visited_last_days"
                              className="docpro_form_field radio_input"
                              value={patientFormData.visited_last_days}
                            />
                            days
                          </div>

                          <Spacing lg="15" sm="15" />
                          <div className="docpro_radio_with_text">
                            <span className="docpro_radio">
                              <input
                                onChange={handlePatientChange}
                                checked={
                                  patientFormData.visit_day_query_type === "2"
                                }
                                type="radio"
                                name="visit_day_query_type"
                                value={2}
                              />
                              <label style={{ marginLeft: "5px" }}>
                                Patients who haven't visited your clinic in
                              </label>
                            </span>
                            <input
                              onChange={handlePatientChange}
                              type="number"
                              min={0}
                              name="not_visited_last_days"
                              value={patientFormData.not_visited_last_days}
                              className="docpro_form_field radio_input"
                            />
                            days
                          </div>
                          <Spacing lg="5" sm="5" />
                        </>
                      )}
                    </div>

                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          handleClearFilters()
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "rejection" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Rejection Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handleReferralFilterSubmit} autoComplete="off">
                    <div
                      className="custom-scroll"
                      style={{
                        maxHeight: "53vh",
                        overflowY: "auto",
                        marginBottom: 0,
                      }}
                    >
                      {/* <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Last Name
                          </label>
                          <input
                            type="text"
                            placeholder="Last Name"
                            className="docpro_form_field"
                            name="last_name"
                            value={referralFilterData.last_name}
                            onChange={handleReferralChange}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            First Name
                          </label>
                          <input
                            type="text"
                            placeholder="First Name"
                            className="docpro_form_field"
                            name="first_name"
                            value={referralFilterData.first_name}
                            onChange={handleReferralChange}
                          />
                        </div>

                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Date of Birth
                          </label>
                          <div className="docpro_input_group">
                            <DatePicker
                              name="dob"
                              placeholderText="mm/dd/yyyy"
                              selected={referralFilterData.dob}
                              onChange={(date) =>
                                handleChangeReferralDate("dob", date)
                              }
                            />
                          </div>
                        </div>

                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Insurance ID
                          </label>
                          <input
                            type="text"
                            placeholder="Insurance ID"
                            className="docpro_form_field"
                            name="insurance_id"
                            value={referralFilterData.insurance_id}
                            onChange={handleReferralChange}
                          />
                        </div>
                      </div>
                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Status
                      </label>
                      <select className="docpro_form_field size_lg" name='status' value={referralFilterData.status} onChange={handleReferralChange} >
                        <option value="">Select Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Paid">Paid</option>
                        <option value="Resubmitted">Resubmitted</option>
                        <option value="Again Denied">Again Denied</option>
                        <option value="Need Help">Need Help</option>
                        <option value="Patient Responsibility">Patient Responsibility</option>
                        <option value="Payment Unable">Payment Unable</option>
                      </select>
                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Insurance
                        {selectedInsuranceOptions.length !== 0 && (
                          <span className="docpro_green_color docpro_fs_14">
                            ({selectedInsuranceOptions.length})
                          </span>
                        )}
                      </label>

                      <MultiSelectWithSearch
                        placeholder="Select insurance"
                        style={{ width: "100%" }}
                        showSearch={true}
                      >
                        {patientInsuranceOptions.map((insurance) => (
                          <li
                            key={insurance.id}
                            onClick={() =>
                              handleReferralInsToggle("insurance_ids", insurance.id)
                            }
                          >
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input
                                type="checkbox"
                                checked={selectedInsuranceOptions.includes(
                                  insurance.id
                                )}
                                readOnly
                                value={insurance.id}
                              />
                              <label>
                                <span style={{ marginLeft: "8px" }}>
                                  {insurance.name}
                                </span>
                              </label>
                            </div>
                          </li>
                        ))}
                      </MultiSelectWithSearch> */}

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_primary_color">
                        <span className="docpro_fw_500">DOS</span> <small className="docpro_accent_color">(From - To)</small>
                      </label>
                      <div className="docpro_input_group">
                        <DatePicker
                          name="dos_from"
                          placeholderText="mm/dd/yyyy"
                          selected={referralFilterData.dos_from}
                          onChange={(date) =>
                            handleChangeReferralDate("dos_from", date)
                          }
                        />
                        -
                        <DatePicker
                          name="dos_to"
                          placeholderText="mm/dd/yyyy"
                          selected={referralFilterData.dos_to}
                          onChange={(date) =>
                            handleChangeReferralDate("dos_to", date)
                          }
                        />
                      </div>

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_primary_color">
                        <span className="docpro_fw_500">Resubmit date</span> <small className="docpro_accent_color">(From - To)</small>
                      </label>
                      <div className="docpro_input_group">
                        <DatePicker
                          name="resubmit_date_from"
                          placeholderText="mm/dd/yyyy"
                          selected={referralFilterData.resubmit_date_from}
                          onChange={(date) =>
                            handleChangeReferralDate("resubmit_date_from", date)
                          }
                        />
                        -
                        <DatePicker
                          name="resubmit_date_to"
                          placeholderText="mm/dd/yyyy"
                          selected={referralFilterData.resubmit_date_to}
                          onChange={(date) =>
                            handleChangeReferralDate("resubmit_date_to", date)
                          }
                        />
                      </div>
                    </div>

                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          setSelectedInsuranceOptions([]);
                          ResetAllFilters(defaultRejectionData);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "patient_caregap" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">CareGap Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handlePatientFilterSubmit} autoComplete="off">
                    <div className="docpro_tab_btns_2">
                      <button
                        type="button"
                        className={`${isReporting === 1 ? "active" : ""}`}
                        onClick={() => setIsReporting(1)}
                      >
                        Patient
                      </button>
                      <button
                        type="button"
                        className={`${isReporting === 2 ? "active" : ""}`}
                        onClick={() => setIsReporting(2)}
                      >
                        Quality Measure
                      </button>
                    </div>
                    <Spacing lg="16" sm="16" />
                    <div className="custom-scroll" >
                      {isReporting === 1 && (
                        <>
                          {/* <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Last Name
                              </label>
                              <input
                                type="text"
                                placeholder="Last Name"
                                className="docpro_form_field"
                                name="last_name"
                                value={patientFormData.last_name}
                                onChange={handlePatientChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                First Name
                              </label>
                              <input
                                type="text"
                                placeholder="First Name"
                                className="docpro_form_field"
                                name="first_name"
                                value={patientFormData.first_name}
                                onChange={handlePatientChange}
                              />
                            </div>

                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Date of Birth
                              </label>
                              <div className="docpro_input_group">
                                <DatePicker
                                  name="dob"
                                  placeholderText="mm/dd/yyyy"
                                  selected={patientFormData.dob}
                                  onChange={(date) =>
                                    handleChangePatientDate("dob", date)
                                  }
                                />
                              </div>
                            </div>

                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Phone
                              </label>
                              <input
                                type="text"
                                className="docpro_form_field us_phone"
                                name="mobile_phone"
                                onChange={handlePatientChange}
                                value={patientFormData.mobile_phone}
                                maxLength={20}
                                placeholder="(123) 123 1234"
                              />
                            </div>
                          </div>
                          <Spacing lg="15" sm="15" />
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                City
                              </label>
                              <input
                                type="text"
                                placeholder="City"
                                className="docpro_form_field"
                                name="city"
                                value={patientFormData.city}
                                onChange={handlePatientChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <div className="docpro_input_group">
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    State
                                  </label>
                                  <input
                                    type="text"
                                    name="state"
                                    placeholder="State"
                                    className="docpro_form_field"
                                    value={patientFormData.state}
                                    onChange={handlePatientChange}
                                  />
                                </div>
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Zip
                                  </label>
                                  <input
                                    type="text"
                                    name="zip"
                                    placeholder="Zip"
                                    className="docpro_form_field"
                                    value={patientFormData.zip}
                                    onChange={handlePatientChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <Spacing lg="15" sm="15" /> */}
                          <label className="docpro_fw_500 docpro_primary_color">
                            Insurance
                            {selectedInsuranceOptions.length !== 0 && (
                              <span className="docpro_green_color docpro_fs_14">
                                ({selectedInsuranceOptions.length})
                              </span>
                            )}
                          </label>

                          <MultiSelectWithSearch
                            placeholder="Select insurance"
                            style={{ width: "100%" }}
                            showSearch={true}
                          >
                            {patientInsuranceOptions.map((insurance) => (
                              <li
                                key={insurance.id}
                                onClick={() =>
                                  handleOptionToggle("insurance_ids", insurance.id)
                                }
                              >
                                <div
                                  className="docpro_checkbox"
                                  style={{ top: "3px" }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedInsuranceOptions.includes(
                                      insurance.id
                                    )}
                                    readOnly
                                    value={insurance.id}
                                  />
                                  <label>
                                    <span style={{ marginLeft: "8px" }}>
                                      {insurance.name}
                                    </span>
                                  </label>
                                </div>
                              </li>
                            ))}
                          </MultiSelectWithSearch>

                          <Spacing lg="15" sm="15" />
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Age range
                              </label>
                              <div className="docpro_input_group">
                                <input
                                  type="number"
                                  name="start_age"
                                  placeholder="0"
                                  className="docpro_form_field"
                                  value={patientFormData.start_age}
                                  onChange={handlePatientChange}
                                />
                                -
                                <input
                                  type="number"
                                  name="end_age"
                                  placeholder="120"
                                  className="docpro_form_field"
                                  value={patientFormData.end_age}
                                  onChange={handlePatientChange}
                                />
                              </div>
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Last Visit
                              </label>
                              <div className="docpro_input_group">
                                <DatePicker
                                  name="last_visit"
                                  placeholderText="mm/dd/yyyy"
                                  selected={patientFormData.last_visit}
                                  onChange={(date) =>
                                    handleChangePatientDate("last_visit", date)
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <Spacing lg="15" sm="15" />
                          <label className="docpro_fw_500 docpro_primary_color">
                            Gender
                          </label>
                          <div className="docpro_radio_group">
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="sex"
                                onChange={handlePatientChange}
                                defaultChecked={patientFormData.sex === "A"}
                                value="A"
                              />
                              <label style={{ paddingLeft: "30px" }}>All</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="sex"
                                onChange={handlePatientChange}
                                defaultChecked={patientFormData.sex === "M"}
                                value="M"
                              />
                              <label style={{ paddingLeft: "30px" }}>Male</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="sex"
                                onChange={handlePatientChange}
                                defaultChecked={patientFormData.sex === "F"}
                                value="F"
                              />
                              <label style={{ paddingLeft: "30px" }}>Female</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="sex"
                                onChange={handlePatientChange}
                                defaultChecked={patientFormData.sex === "U"}
                                value="U"
                              />
                              <label style={{ paddingLeft: "30px" }}>Other</label>
                            </div>
                          </div>
                          <Spacing lg="15" sm="15" />

                          <div className="docpro_radio_with_text">
                            <span className="docpro_radio">
                              <input
                                onChange={handlePatientChange}
                                checked={
                                  patientFormData.visit_day_query_type === "1"
                                }
                                type="radio"
                                name="visit_day_query_type"
                                value={1}
                              />
                              <label style={{ marginLeft: "5px" }}>
                                Patients who visited your clinic in
                              </label>
                            </span>
                            <input
                              onChange={handlePatientChange}
                              type="number"
                              min={0}
                              name="visited_last_days"
                              className="docpro_form_field radio_input"
                              value={patientFormData.visited_last_days}
                            />
                            days
                          </div>

                          <Spacing lg="15" sm="15" />
                          <div className="docpro_radio_with_text">
                            <span className="docpro_radio">
                              <input
                                onChange={handlePatientChange}
                                checked={
                                  patientFormData.visit_day_query_type === "2"
                                }
                                type="radio"
                                name="visit_day_query_type"
                                value={2}
                              />
                              <label style={{ marginLeft: "5px" }}>
                                Patients who haven't visited your clinic in
                              </label>
                            </span>
                            <input
                              onChange={handlePatientChange}
                              type="number"
                              min={0}
                              name="not_visited_last_days"
                              value={patientFormData.not_visited_last_days}
                              className="docpro_form_field radio_input"
                            />
                            days
                          </div>
                        </>
                      )}
                      {isReporting === 2 && (
                        <>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Quality Measure
                            </label>

                            <ul className="mb-0" style={{ listStyle: "none", paddingLeft: "10px" }}>
                              {measuresData.map((item) => (
                                <li key={item.id} style={{ marginBottom: "5px" }}>
                                  <div style={{ display: "flex" }}>
                                    <div className="docpro_checkbox" style={{ top: "3px" }}>
                                      <input
                                        type="checkbox"
                                        value={item.id}
                                        name="id"
                                        defaultChecked={selectedMeasures?.some(
                                          (measure) => measure.id === item.id
                                        )}
                                        onChange={(e) => {
                                          const id = parseInt(e.target.value, 10);
                                          const isChecked = e.target.checked;
                                          handleQMToggle("quality_measure", id, isChecked, "pending");
                                        }}
                                      />
                                      <label style={{ marginLeft: "8px" }}> {item.name} </label>
                                    </div>

                                    <select
                                      name="status"
                                      style={{
                                        paddingRight: "24px",
                                        marginLeft: "10px",
                                        border: 0,
                                        borderBottom: "1px solid #d3d4db",
                                        borderRadius: 0,
                                      }}
                                      value={
                                        selectedMeasures?.find((measure) => measure.id === item.id)
                                          ?.status || "pending"
                                      }
                                      onChange={(e) => {
                                        const newStatus = e.target.value;
                                        const id = item.id;
                                        const isChecked = true;
                                        handleQMToggle("quality_measure", id, isChecked, newStatus);
                                      }}
                                    >
                                      <option value="pending">Pending</option>
                                      <option value="completed">Done</option>
                                    </select>
                                  </div>
                                </li>
                              ))}
                            </ul>

                          </div>
                        </>
                      )}
                      <Spacing lg="5" sm="5" />
                    </div>
                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          setSelectedInsuranceOptions([]);
                          ResetAllFilters(patientDefaultValues);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        type="submit"
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "patient_mips" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">MIPS Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handlePatientFilterSubmit} autoComplete="off">
                    <div className="custom-scroll" >
                      <label className="docpro_fw_500 docpro_primary_color">
                        Age range
                      </label>
                      <div className="docpro_input_group">
                        <input
                          type="number"
                          name="start_age"
                          placeholder="0"
                          className="docpro_form_field"
                          value={patientFormData.start_age}
                          onChange={handlePatientChange}
                        />
                        -
                        <input
                          type="number"
                          name="end_age"
                          placeholder="120"
                          className="docpro_form_field"
                          value={patientFormData.end_age}
                          onChange={handlePatientChange}
                        />
                      </div>

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender
                      </label>
                      <div className="docpro_radio_group">
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "All"}
                            value="All"
                          />
                          <label style={{ paddingLeft: "30px" }}>All</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "Male"}
                            value="Male"
                          />
                          <label style={{ paddingLeft: "30px" }}>Male</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "Female"}
                            value="Female"
                          />
                          <label style={{ paddingLeft: "30px" }}>Female</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="sex"
                            onChange={handlePatientChange}
                            defaultChecked={patientFormData.sex === "Other"}
                            value="Other"
                          />
                          <label style={{ paddingLeft: "30px" }}>Other</label>
                        </div>
                      </div>

                      <Spacing lg="15" sm="15" />
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          MIPS
                        </label>

                        <ul className="mb-0" style={{ listStyle: "none", paddingLeft: "10px" }}>
                          {Object.entries(allMips)?.map(([key, name]) => (
                            <li key={key} style={{ marginBottom: "5px" }}>
                              <div style={{ display: "flex" }}>
                                <div className="docpro_checkbox" style={{ top: "3px" }}>
                                  <input
                                    type="checkbox"
                                    value={key}
                                    name="id"
                                    defaultChecked={selectedMips?.some(
                                      (measure) => measure.id === key
                                    )}
                                    onChange={(e) => {
                                      const id =e.target.value;
                                      const isChecked = e.target.checked;
                                      handleMIPSToggle("mips", id, isChecked, "Eligible");
                                    }}
                                  />
                                  <label style={{ marginLeft: "8px" }}> {name} </label>
                                </div>

                                <select
                                  name="status"
                                  style={{
                                    paddingRight: "24px",
                                    marginLeft: "10px",
                                    border: 0,
                                    borderBottom: "1px solid #d3d4db",
                                    borderRadius: 0,
                                  }}
                                  value={
                                    selectedMips?.find((measure) => measure.id === key)
                                      ?.status || "Eligible"
                                  }
                                  onChange={(e) => {
                                    const newStatus = e.target.value;
                                    const id = key;
                                    const isChecked = true;
                                    handleMIPSToggle("mips", id, isChecked, newStatus);
                                  }}
                                >
                                  <option value="Eligible">Eligible</option>
                                  <option value="Not Eligible">Not Eligible</option>
                                </select>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          ResetAllFilters(defaultMipsFilter);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        type="submit"
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "ai_patient" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Filter Chart</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handleAIChartingFilterSubmit} autoComplete="off">
                    {/* <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Last Name
                        </label>
                        <input
                          type="text"
                          placeholder="Last Name"
                          className="docpro_form_field"
                          name="last_name"
                          value={patientFormData.last_name}
                          onChange={handlePatientChange}
                        />
                      </div>
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          First Name
                        </label>
                        <input
                          type="text"
                          placeholder="First Name"
                          className="docpro_form_field"
                          name="first_name"
                          value={patientFormData.first_name}
                          onChange={handlePatientChange}
                        />
                      </div>

                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Date of Birth
                        </label>
                        <div className="docpro_input_group">
                          <DatePicker
                            name="dob"
                            placeholderText="mm/dd/yyyy"
                            selected={patientFormData.dob}
                            onChange={(date) =>
                              handleChangePatientDate("dob", date)
                            }
                          />
                        </div>
                      </div>

                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Phone
                        </label>
                        <input
                          type="text"
                          className="docpro_form_field us_phone"
                          name="mobile_phone"
                          onChange={handlePatientChange}
                          value={patientFormData.mobile_phone}
                          maxLength={20}
                          placeholder="(123) 123 1234"
                        />
                      </div>
                    </div>
                    <Spacing lg="15" sm="15" />
                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          City
                        </label>
                        <input
                          type="text"
                          placeholder="City"
                          className="docpro_form_field"
                          name="city"
                          value={patientFormData.city}
                          onChange={handlePatientChange}
                        />
                      </div>
                      <div className="docpro_grid_item">
                        <div className="docpro_input_group">
                          <div>
                            <label className="docpro_fw_500 docpro_primary_color">
                              State
                            </label>
                            <input
                              type="text"
                              name="state"
                              placeholder="State"
                              className="docpro_form_field"
                              value={patientFormData.state}
                              onChange={handlePatientChange}
                            />
                          </div>
                          <div>
                            <label className="docpro_fw_500 docpro_primary_color">
                              Zip
                            </label>
                            <input
                              type="text"
                              name="zip"
                              placeholder="Zip"
                              className="docpro_form_field"
                              value={patientFormData.zip}
                              onChange={handlePatientChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <Spacing lg="15" sm="15" /> */}
                    <label className="docpro_fw_500 docpro_primary_color">
                      Insurance
                      {selectedInsuranceOptions.length !== 0 && (
                        <span className="docpro_green_color docpro_fs_14">
                          ({selectedInsuranceOptions.length})
                        </span>
                      )}
                    </label>

                    <MultiSelectWithSearch
                      placeholder="Select insurance"
                      style={{ width: "100%" }}
                      showSearch={true}
                    >
                      {patientInsuranceOptions.map((insurance) => (
                        <li
                          key={insurance.id}
                          onClick={() =>
                            handleOptionToggle("insurance_ids", insurance.id)
                          }
                        >
                          <div className="docpro_checkbox" style={{ top: "3px" }}>
                            <input
                              type="checkbox"
                              checked={selectedInsuranceOptions.includes(
                                insurance.id
                              )}
                              readOnly
                              value={insurance.id}
                            />
                            <label>
                              <span style={{ marginLeft: "8px" }}>
                                {insurance.name}
                              </span>
                            </label>
                          </div>
                        </li>
                      ))}
                    </MultiSelectWithSearch>

                    <Spacing lg="15" sm="15" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Visit Type
                    </label>
                    <div className="docpro_input_group" onClick={(e) => e.stopPropagation()}>
                      <Select
                        name="vt_name"
                        options={vtOptions}
                        onChange={handleRFVChange}
                        placeholder="Search.."
                        isSearchable={true}
                        value={vtOptions.find((option) => option?.value === patientFormData.vt_name) || null}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '36px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                    </div>

                    <Spacing lg="15" sm="15" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Gender
                    </label>
                    <div className="docpro_radio_group">
                      <div className="docpro_radio">
                        <input
                          type="radio"
                          name="sex"
                          onChange={handlePatientChange}
                          defaultChecked={patientFormData.sex === "A"}
                          value="A"
                        />
                        <label style={{ paddingLeft: "30px" }}>All</label>
                      </div>
                      <div className="docpro_radio">
                        <input
                          type="radio"
                          name="sex"
                          onChange={handlePatientChange}
                          defaultChecked={patientFormData.sex === "M"}
                          value="M"
                        />
                        <label style={{ paddingLeft: "30px" }}>Male</label>
                      </div>
                      <div className="docpro_radio">
                        <input
                          type="radio"
                          name="sex"
                          onChange={handlePatientChange}
                          defaultChecked={patientFormData.sex === "F"}
                          value="F"
                        />
                        <label style={{ paddingLeft: "30px" }}>Female</label>
                      </div>
                      <div className="docpro_radio">
                        <input
                          type="radio"
                          name="sex"
                          onChange={handlePatientChange}
                          defaultChecked={patientFormData.sex === "U"}
                          value="U"
                        />
                        <label style={{ paddingLeft: "30px" }}>Other</label>
                      </div>
                    </div>

                    <Spacing lg="28" sm="28" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          setSelectedInsuranceOptions([]);
                          ResetAllFilters(patientDefaultValues);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "easy_referral" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Referral Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form
                    onSubmit={handleEasyReferralFilterSubmit}
                    autoComplete="off"
                  >
                    <div className="docpro_tab_btns_2">
                      <button
                        type="button"
                        className={`${isReferralReporting === 1 ? "active" : ""}`}
                        onClick={() => setIsReferralReporting(1)}
                      >
                        Patient
                      </button>
                      <button
                        type="button"
                        className={`${isReferralReporting === 2 ? "active" : ""}`}
                        onClick={() => setIsReferralReporting(2)}
                      >
                        Specialist
                      </button>
                    </div>
                    <Spacing lg="16" sm="16" />

                    <div className="custom-scroll">
                      {isReferralReporting === 1 && (
                        <>
                          {/* <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Last Name
                              </label>
                              <input
                                type="text"
                                placeholder="Last Name"
                                className="docpro_form_field"
                                name="patient_last_name"
                                value={reloadReferralFilter?.patient_last_name}
                                onChange={handlereferralChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                First Name
                              </label>
                              <input
                                type="text"
                                placeholder="First Name"
                                className="docpro_form_field"
                                name="patient_first_name"
                                value={reloadReferralFilter?.patient_first_name}
                                onChange={handlereferralChange}
                              />
                            </div>

                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Date of Birth
                              </label>
                              <div className="docpro_input_group">
                                <DatePicker
                                  name="patient_dob"
                                  placeholderText="mm/dd/yyyy"
                                  selected={reloadReferralFilter?.patient_dob}
                                  onChange={(date) =>
                                    handleChangeReferDate("patient_dob", date)
                                  }
                                />
                              </div>
                            </div>

                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Phone
                              </label>
                              <input
                                type="text"
                                className="docpro_form_field us_phone"
                                name="patient_mobile_phone"
                                onChange={handlereferralChange}
                                value={reloadReferralFilter?.patient_mobile_phone}
                                maxLength={20}
                                placeholder="(123) 123 1234"
                              />
                            </div>
                          </div>
                          <Spacing lg="15" sm="15" />
                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                City
                              </label>
                              <input
                                type="text"
                                placeholder="City"
                                className="docpro_form_field"
                                name="patient_city"
                                value={reloadReferralFilter?.patient_city}
                                onChange={handlereferralChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <div className="docpro_input_group">
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    State
                                  </label>
                                  <input
                                    type="text"
                                    name="patient_state"
                                    placeholder="State"
                                    className="docpro_form_field"
                                    value={reloadReferralFilter?.patient_state}
                                    onChange={handlereferralChange}
                                  />
                                </div>
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Zip
                                  </label>
                                  <input
                                    type="text"
                                    name="patient_zip"
                                    placeholder="Zip"
                                    className="docpro_form_field"
                                    value={reloadReferralFilter?.patient_zip}
                                    onChange={handlereferralChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <Spacing lg="15" sm="15" /> */}
                          <label className="docpro_fw_500 docpro_primary_color">
                            Insurance
                            {selectedInsuranceOptions.length !== 0 && (
                              <span className="docpro_green_color docpro_fs_14">
                                ({selectedInsuranceOptions.length})
                              </span>
                            )}
                          </label>

                          <MultiSelectWithSearch
                            placeholder="Select insurance"
                            style={{ width: "100%" }}
                            showSearch={true}
                          >
                            {patientInsuranceOptions.map((insurance) => (
                              <li
                                key={insurance.id}
                                onClick={() =>
                                  handleInsuranceOptionToggle(
                                    "patient_insurance_ids",
                                    insurance.id
                                  )
                                }
                              >
                                <div
                                  className="docpro_checkbox"
                                  style={{ top: "3px" }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedInsuranceOptions.includes(
                                      insurance.id
                                    )}
                                    readOnly
                                    value={insurance.id}
                                  />
                                  <label>
                                    <span style={{ marginLeft: "8px" }}>
                                      {insurance.name}
                                    </span>
                                  </label>
                                </div>
                              </li>
                            ))}
                          </MultiSelectWithSearch>

                          <Spacing lg="15" sm="15" />
                          <label className="docpro_fw_500 docpro_primary_color">
                            Gender
                          </label>
                          <div className="docpro_radio_group">
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="patient_sex"
                                onChange={handlereferralChange}
                                defaultChecked={
                                  reloadReferralFilter?.patient_sex === "A"
                                }
                                value="A"
                              />
                              <label style={{ paddingLeft: "30px" }}>All</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="patient_sex"
                                onChange={handlereferralChange}
                                defaultChecked={
                                  reloadReferralFilter?.patient_sex === "M"
                                }
                                value="M"
                              />
                              <label style={{ paddingLeft: "30px" }}>Male</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="patient_sex"
                                onChange={handlereferralChange}
                                defaultChecked={
                                  reloadReferralFilter?.patient_sex === "F"
                                }
                                value="F"
                              />
                              <label style={{ paddingLeft: "30px" }}>Female</label>
                            </div>
                            <div className="docpro_radio">
                              <input
                                type="radio"
                                name="patient_sex"
                                onChange={handlereferralChange}
                                defaultChecked={
                                  reloadReferralFilter?.patient_sex === "U"
                                }
                                value="U"
                              />
                              <label style={{ paddingLeft: "30px" }}>Other</label>
                            </div>
                          </div>
                        </>
                      )}
                      {isReferralReporting === 2 && (
                        <>
                          <label className="docpro_fw_500 docpro_primary_color">
                            Specialty
                            {selectedSpecialityOptions.length !== 0 && (
                              <span className="docpro_green_color docpro_fs_14">
                                ({selectedSpecialityOptions.length})
                              </span>
                            )}
                          </label>

                          <MultiSelectWithSearch
                            placeholder="Select specialty"
                            style={{ width: "100%" }}
                            showSearch={true}
                          >
                            {practiceSpecialityOptions.map((speciality) => (
                              <li
                                key={speciality.id}
                                onClick={() =>
                                  handleReferSpecialityToggle(
                                    "speciality_ids",
                                    speciality.id
                                  )
                                }
                              >
                                <div
                                  className="docpro_checkbox"
                                  style={{ top: "3px" }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedSpecialityOptions.includes(
                                      speciality.id
                                    )}
                                    readOnly
                                    value={speciality.id}
                                  />
                                  <label>
                                    <span style={{ marginLeft: "8px" }}>
                                      {speciality.name}
                                    </span>
                                  </label>
                                </div>
                              </li>
                            ))}
                          </MultiSelectWithSearch>
                          <Spacing lg="15" sm="15" />
                          
                          <div className="">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Practice Name
                            </label>
                            <input
                              type="text"
                              placeholder="Practice Name"
                              className="docpro_form_field"
                              name="practice_name"
                              value={reloadReferralFilter?.practice_name}
                              onChange={handlereferralChange}
                            />
                          </div>
                          <Spacing lg="15" sm="15" />

                          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Provider Name
                              </label>
                              <input
                                type="text"
                                placeholder="Provider Name"
                                className="docpro_form_field"
                                name="provider_name"
                                value={reloadReferralFilter?.provider_name}
                                onChange={handlereferralChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Phone
                              </label>
                              <input
                                type="text"
                                className="docpro_form_field us_phone"
                                name="practice_mobile_phone"
                                onChange={handlereferralChange}
                                value={reloadReferralFilter?.practice_mobile_phone}
                                maxLength={20}
                                placeholder="(123) 123 1234"
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <label className="docpro_fw_500 docpro_primary_color">
                                Street
                              </label>
                              <input
                                type="text"
                                placeholder="Street"
                                className="docpro_form_field"
                                name="practice_street"
                                value={reloadReferralFilter?.practice_street}
                                onChange={handlereferralChange}
                              />
                            </div>
                            <div className="docpro_grid_item">
                              <div className="docpro_input_group">
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="practice_city"
                                    placeholder="City"
                                    className="docpro_form_field"
                                    value={reloadReferralFilter?.practice_city}
                                    onChange={handlereferralChange}
                                  />
                                </div>
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    State
                                  </label>
                                  <input
                                    type="text"
                                    name="practice_state"
                                    placeholder="State"
                                    className="docpro_form_field"
                                    value={reloadReferralFilter?.practice_state}
                                    onChange={handlereferralChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <Spacing lg="5" sm="5" />
                    </div>
                    <Spacing lg="25" sm="25" />

                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          setSelectedInsuranceOptions([]);
                          ResetAllFilters(patientDefaultValues);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "specialist" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Specialist Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handlePracticeFilterSubmit} autoComplete="off">
                    <div className="custom-scroll" >
                    <label className="docpro_fw_500 docpro_primary_color">
                        Specialty
                        {selectedSpecialityOptions.length !== 0 && (
                          <span className="docpro_green_color docpro_fs_14">
                            ({selectedSpecialityOptions.length})
                          </span>
                        )}
                      </label>

                      <MultiSelectWithSearch
                        placeholder="Select specialty"
                        style={{ width: "100%" }}
                        showSearch={true}
                      >
                        {practiceSpecialityOptions.map((speciality) => (
                          <li
                            key={speciality.id}
                            onClick={() =>
                              handleSpecialityToggle(
                                "speciality_ids",
                                speciality.id
                              )
                            }
                          >
                            <div className="docpro_checkbox" style={{ top: "3px" }}>
                              <input
                                type="checkbox"
                                checked={selectedSpecialityOptions.includes(
                                  speciality.id
                                )}
                                readOnly
                                value={speciality.id}
                              />
                              <label>
                                <span style={{ marginLeft: "8px" }}>
                                  {speciality.name}
                                </span>
                              </label>
                            </div>
                          </li>
                        ))}
                      </MultiSelectWithSearch>
                      <Spacing lg="15" sm="15" />

                      <div className="">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Provider Name
                        </label>
                        <input
                          type="text"
                          placeholder="Provider Name"
                          className="docpro_form_field"
                          name="provider_name"
                          value={practiceFormData.provider_name}
                          onChange={handlePracticeChange}
                        />
                      </div>
                      <Spacing lg="15" sm="15" />
                      <div className="">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Practice Name
                        </label>
                        <input
                          type="text"
                          placeholder="Practice Name"
                          className="docpro_form_field"
                          name="practice_name"
                          value={practiceFormData.practice_name}
                          onChange={handlePracticeChange}
                        />
                      </div>
                      <Spacing lg="15" sm="15" />
                      <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            City
                          </label>
                          <input
                            type="text"
                            placeholder="City"
                            className="docpro_form_field"
                            name="city"
                            value={practiceFormData.city}
                            onChange={handlePracticeChange}
                          />
                        </div>
                        <div className="docpro_grid_item">
                          <div className="docpro_input_group">
                            <div>
                              <label className="docpro_fw_500 docpro_primary_color">
                                State
                              </label>
                              <input
                                type="text"
                                name="practice_state"
                                placeholder="State"
                                className="docpro_form_field"
                                value={practiceFormData.practice_state}
                                onChange={handlePracticeChange}
                              />
                            </div>
                            <div>
                              <label className="docpro_fw_500 docpro_primary_color">
                                Zip
                              </label>
                              <input
                                type="text"
                                name="postal_code"
                                placeholder="Zip"
                                className="docpro_form_field"
                                value={practiceFormData.postal_code}
                                onChange={handlePracticeChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          setSelectedSpecialityOptions([]);
                          ResetAllFilters(practiceDefaultValues);
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "fidelis_care" && (
                <div className="docpro_filter_dropdown_body custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Fidelis Patient Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handleFidelisPatientFilterSubmit} autoComplete="off">
                    <div className="custom-scroll" >
                      <label className="docpro_fw_500 docpro_primary_color">
                        Practice Location
                      </label>
                      <Select
                        name="practice_location"
                        options={practiceLocationsOptions}
                        onChange={(selectedOption) => {
                          setPatientFormData({ ...patientFormData, practice_location: selectedOption.value });
                        }}
                        placeholder="Search Location..."
                        isSearchable={true}
                        value={practiceLocationsOptions.find(
                          (option) => option.value === patientFormData.practice_location
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                      />

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Visit Status
                      </label>
                      <Select
                        name="visit_status"
                        options={visitStatusOptions}
                        onChange={(selectedOption) => {
                          setPatientFormData({ ...patientFormData, visit_status: selectedOption.value });
                        }}
                        placeholder="Search Status..."
                        isSearchable={true}
                        value={visitStatusOptions.find(
                          (option) => option.value === patientFormData.visit_status
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                      />

                      <Spacing lg="15" sm="15" />
                      <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            Start Date
                          </label>
                          <div className="docpro_input_group">
                            <DatePicker
                              name="start_date"
                              placeholderText="mm/dd/yyyy"
                              selected={patientFormData.start_date}
                              onChange={(date) =>
                                handleChangeFidelisPatientDate("start_date", date)
                              }
                            />
                          </div>
                        </div>
                        <div className="docpro_grid_item">
                          <label className="docpro_fw_500 docpro_primary_color">
                            End Date
                          </label>
                          <div className="docpro_input_group">
                            <DatePicker
                              name="end_date"
                              placeholderText="mm/dd/yyyy"
                              selected={patientFormData.end_date}
                              onChange={(date) =>
                                handleChangeFidelisPatientDate("end_date", date)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Gender
                      </label>
                      <div className="docpro_radio_group">
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="gender"
                            onChange={handleChangeFidelisPatientData}
                            defaultChecked={patientFormData.gender === ""}
                            value=""
                          />
                          <label style={{ paddingLeft: "30px" }}>All</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="gender"
                            onChange={handleChangeFidelisPatientData}
                            defaultChecked={patientFormData.gender === "Male"}
                            value="Male"
                          />
                          <label style={{ paddingLeft: "30px" }}>Male</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="gender"
                            onChange={handleChangeFidelisPatientData}
                            defaultChecked={patientFormData.gender === "Female"}
                            value="Female"
                          />
                          <label style={{ paddingLeft: "30px" }}>Female</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="gender"
                            onChange={handleChangeFidelisPatientData}
                            defaultChecked={patientFormData.gender === "Other"}
                            value="Other"
                          />
                          <label style={{ paddingLeft: "30px" }}>Other</label>
                        </div>
                      </div>
                    </div>

                    <Spacing lg="25" sm="25" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={() => {
                          handleClearFidelisFilters()
                        }}
                      >
                        Reset all filters
                      </button>
                      <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                        type="submit"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
              {filterType === "fidelis_incoming" && (
                <div className="docpro_filter_dropdown_body docpro_size_md custom-scroll" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)` }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Fidelis Care Filter</h4>
                  <Spacing lg="16" sm="16" />
                  <label className="docpro_fw_500 docpro_primary_color">
                    Date range (DOS)
                  </label>
                  <div className="docpro_input_group">
                    <DatePicker
                      name="start_date"
                      placeholderText="mm/dd/yyyy"
                      selected={patientFormData.start_date}
                      onChange={(date) =>
                        handleChangeFidelisPatientDate("start_date", date)
                      }
                    />
                    -
                    <DatePicker
                      name="end_date"
                      placeholderText="mm/dd/yyyy"
                      selected={patientFormData.end_date}
                      onChange={(date) =>
                        handleChangeFidelisPatientDate("end_date", date)
                      }
                    />
                  </div>
                  <Spacing lg="28" sm="28" />
                  <div className="docpro_filter_dropdown_btns">
                    <button
                      className="docpro_text_btn docpro_accent_color docpro_fw_600"
                      onClick={handleClearFidelisIncomingFilters}
                    >
                      Reset all filters
                    </button>
                    <button
                      className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                      onClick={handleGenerateIncomingMessage}
                    >
                      <UserSearch /> Generate
                    </button>
                  </div>
                </div>
              )}
              {filterType === "fidelis_outgoing" && (
                <div className="docpro_filter_dropdown_body docpro_size_md" style={{ maxHeight: `calc(100vh - ${drawerPosition.top + 20}px)`, overflow: 'visible' }}>
                  <h4 className="docpro_fs_18 docpro_mb_0">Fidelis Care Filter</h4>
                  <Spacing lg="16" sm="16" />

                  <form onSubmit={handleGenerateOutgoingMessage} autoComplete="off">
                    <div className="custom-scroll" >
                      <label className="docpro_fw_500 docpro_primary_color">
                        Practice Location
                      </label>
                      <Select
                        name="practice_location"
                        options={practiceLocationsOptions}
                        onChange={(selectedOption) => {
                          setPatientFormData({ ...patientFormData, practice_location: selectedOption.value });
                        }}
                        placeholder="Search Location..."
                        isSearchable={true}
                        value={practiceLocationsOptions.find(
                          (option) => option.value === patientFormData.practice_location
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                      />

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Select Category
                      </label>
                      <Select
                        name="template_id"
                        options={allMessageTemplate}
                        onChange={(selectedOption) => {
                          setPatientFormData({ ...patientFormData, template_id: selectedOption.value });
                        }}
                        placeholder="Search Template..."
                        isSearchable={true}
                        value={allMessageTemplate.find(
                          (option) => option.value === patientFormData.template_id
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                      />

                      <Spacing lg="15" sm="15" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Select Status
                      </label>
                      <Select
                        name="status"
                        options={allStatusOptions}
                        onChange={(selectedOption) => {
                          setPatientFormData({ ...patientFormData, status: selectedOption.value });
                        }}
                        placeholder="Search Status..."
                        isSearchable={true}
                        value={allStatusOptions.find(
                          (option) => option.value === patientFormData.status
                        )}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        styles={selectStyles}
                      />
                    </div>

                    <Spacing lg="28" sm="28" />
                    <div className="docpro_filter_dropdown_btns">
                      <button
                        type="button"
                        className="docpro_text_btn docpro_accent_color docpro_fw_600"
                        onClick={handleClearFidelisOutgoingFilters}
                      >
                        Reset all filters
                      </button>
                      <button
                        type="submit"
                        className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                      >
                        <UserSearch /> Generate
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
